import { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: 'inspect',
    name: 'inspect',
    component: () => import('@/layout/routerView.vue'),
    redirect: '/inspect/list',
    meta: { title: '巡检管理', icon: 'svg:menu-inspection', order: 90 },
    children: [
      { path: 'list', name: 'inspect_list', component: () => import('@/views/Inspect/List/index.vue'), meta: { title: '巡检列表' } },
      { path: 'config', name: 'inspect_config', component: () => import('@/views/Inspect/Config/index.vue'), meta: { title: '巡检项配置' } },
      { path: 'category', name: 'inspect_category', component: () => import('@/views/Inspect/Category/index.vue'), meta: { title: '巡检分类', order: 60 } }
    ]
  }
]

export default routes
